// Test function to check and create cross-domain links
// You can call this from browser console: window.testCrossDomain()

export const testCrossDomain = () => {
  console.log('=== CROSS-DOMAIN TEST ===');
  
  // Check what Discord data we have
  const localStorage_uid = localStorage.getItem('discord_uid');
  const cookie_discord_id = getCookie('discord_id');
  const cookie_discordUID = getCookie('discordUID');
  
  console.log('localStorage discord_uid:', localStorage_uid);
  console.log('Cookie discord_id:', cookie_discord_id);
  console.log('Cookie discordUID:', cookie_discordUID);
  console.log('All cookies:', document.cookie);
  
  // Get the best UID available
  const uid = localStorage_uid || cookie_discord_id || cookie_discordUID;
  
  if (uid) {
    console.log('✅ Found Discord UID:', uid);
    
    // Store in localStorage if not already there
    if (!localStorage_uid) {
      localStorage.setItem('discord_uid', uid);
      console.log('📝 Stored UID in localStorage for cross-domain access');
    }
    
    // Create test links
    const gameLink = createCrossDomainLink('http://localhost:3000'); // Adjust URL as needed
    console.log('🎮 WUMZ Game Link:', gameLink);
    
    // Test the link
    console.log('🔗 Click this link to test:', gameLink);
    return gameLink;
  } else {
    console.log('❌ No Discord UID found - user not authenticated');
    return null;
  }
};

// Helper function to get cookies
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Create cross-domain links
const createCrossDomainLink = (targetUrl) => {
  const uid = localStorage.getItem('discord_uid') || getCookie('discord_id') || getCookie('discordUID');
  if (!uid) return targetUrl;
  
  const url = new URL(targetUrl);
  url.searchParams.set('discord_uid', uid);
  return url.toString();
};

// Test localStorage clearing manually
export const testLogoutClear = () => {
  console.log('=== MANUAL LOGOUT TEST ===');
  console.log('Before clear - localStorage discord_uid:', localStorage.getItem('discord_uid'));
  
  // Try multiple clearing methods
  localStorage.removeItem('discord_uid');
  console.log('After removeItem - localStorage discord_uid:', localStorage.getItem('discord_uid'));
  
  // Also try setting to null
  localStorage.setItem('discord_uid', null);
  console.log('After setItem(null) - localStorage discord_uid:', localStorage.getItem('discord_uid'));
  
  // Remove again
  localStorage.removeItem('discord_uid');
  console.log('Final state - localStorage discord_uid:', localStorage.getItem('discord_uid'));
  
  return localStorage.getItem('discord_uid');
};

// Make it available globally for testing
if (typeof window !== 'undefined') {
  window.testCrossDomain = testCrossDomain;
  window.createGameLink = (gameUrl) => createCrossDomainLink(gameUrl);
  window.testLogoutClear = testLogoutClear;
}